<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App component serves as the root component
</script>